import React from "react";

import {
  FaDownload,
  FaEraser,
  FaFilter,
  FaSearch,
  FaSyncAlt,
} from "react-icons/fa";

const STATUS_OPTIONS = [
  {
    value: "",
    label: "Tous les statuts",
  },
  {
    value: "draft",
    label: "Brouillon",
  },
  {
    value: "submitted",
    label: "Soumise",
  },
  {
    value: "approved",
    label: "Approuvée",
  },
  {
    value: "rejected",
    label: "Rejetée",
  },
  {
    value: "paid",
    label: "Payée",
  },
];

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500">
        {label}
      </div>

      {children}
    </label>
  );
}

const inputClass =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition focus:border-sky-400 focus:ring-4 focus:ring-sky-100";

export default function ExpenseFilters({
  filters,
  onChange,
  onSubmit,
  onReset,
  onRefresh,
  onExport,
  budgetCodes = [],
  eventOptions = [],
  loading = false,
  exporting = false,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm"
    >
      <div className="mb-4 flex items-center gap-3">
        <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-sky-50 text-sky-700 ring-1 ring-sky-200">
          <FaFilter />
        </div>

        <div>
          <div className="text-lg font-black text-slate-900">
            Filtres
          </div>

          <div className="text-sm text-slate-500">
            Recherche, statut, réunion ou événement,
            code budgétaire et période.
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">
        <Field label="Recherche">
          <input
            type="text"
            className={inputClass}
            placeholder="Nom, prénom, email…"
            value={filters.q}
            onChange={(event) =>
              onChange(
                "q",
                event.target.value,
              )
            }
          />
        </Field>

        <Field label="Statut">
          <select
            className={inputClass}
            value={filters.status}
            onChange={(event) =>
              onChange(
                "status",
                event.target.value,
              )
            }
          >
            {STATUS_OPTIONS.map((option) => (
              <option
                key={option.value || "all"}
                value={option.value}
              >
                {option.label}
              </option>
            ))}
          </select>
        </Field>

        <Field label="Réunion / événement">
          <select
            className={inputClass}
            value={filters.eventId}
            onChange={(event) =>
              onChange(
                "eventId",
                event.target.value,
              )
            }
          >
            <option value="">
              Toutes les réunions et événements
            </option>

            {eventOptions.map((eventOption) => (
              <option
                key={eventOption.value}
                value={eventOption.value}
              >
                {eventOption.label}
              </option>
            ))}
          </select>
        </Field>

        <Field label="Code budgétaire">
          <select
            className={inputClass}
            value={filters.budgetCodeId}
            onChange={(event) =>
              onChange(
                "budgetCodeId",
                event.target.value,
              )
            }
          >
            <option value="">
              Tous les codes
            </option>

            {budgetCodes.map((code) => (
              <option
                key={code.id}
                value={code.id}
              >
                {code.code} · {code.libelle}
              </option>
            ))}
          </select>
        </Field>

        <Field label="Du">
          <input
            type="date"
            className={inputClass}
            value={filters.from}
            onChange={(event) =>
              onChange(
                "from",
                event.target.value,
              )
            }
          />
        </Field>

        <Field label="Au">
          <input
            type="date"
            className={inputClass}
            value={filters.to}
            onChange={(event) =>
              onChange(
                "to",
                event.target.value,
              )
            }
          />
        </Field>
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-3">
        <button
          type="submit"
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <FaSearch />
          Rechercher
        </button>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
        >
          <FaEraser />
          Réinitialiser
        </button>

        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <FaSyncAlt />
          Actualiser
        </button>

        <button
          type="button"
          onClick={onExport}
          disabled={loading || exporting}
          className="inline-flex items-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <FaDownload />

          {exporting
            ? "Export..."
            : "Exporter Excel (.csv)"}
        </button>
      </div>
    </form>
  );
}